/*
 * PANORAMA 360 — sélecteur de profils de l'espace membre (maquette), bouton « Copier » du parrainage,
 * messages des boutons de démonstration, ligne Pano Points du panier, reflet holographique de la carte,
 * simulateur du cadran, ticket à gratter du jour et « Devine le prix » (maquette).
 * Chargé par plusieurs snippets : on se protège contre une double initialisation.
 */
(function () {
  if (window.__p360Ready) return;
  window.__p360Ready = true;

  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'p360-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 3600);
  }

  function fmt(n) {
    return Math.round(n).toLocaleString('fr-FR');
  }

  function store(key, value) {
    try {
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {}
  }

  function load(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setProfile(key) {
    document.querySelectorAll('[data-p360-dashboard]').forEach(function (dash) {
      dash.hidden = dash.getAttribute('data-p360-dashboard') !== key;
      if (!dash.hidden) initGames(dash);
    });
    document.querySelectorAll('[data-p360-profile]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-p360-profile') === key ? 'true' : 'false');
    });
  }

  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        function () {
          toast('Code ' + text + ' copié.');
        },
        function () {
          toast('Ton code : ' + text);
        }
      );
    } else {
      toast('Ton code : ' + text);
    }
  }

  /*
   * Ligne « cette commande te rapporte X Pano Points » sous le total du panier (tiroir et page panier).
   * Maquette : ajoutée en JS pour ne pas modifier snippets/cart-drawer.liquid ;
   * la version Liquid équivalente est snippets/p360-cart-earn.liquid.
   */
  var CART_ICON =
    '<svg class="p360-dial p360-dial--compact" viewBox="0 0 240 240" aria-hidden="true" focusable="false">' +
    '<defs><linearGradient id="p360h-cart" x1="0" y1="0" x2="1" y2="1">' +
    '<stop class="p360-h1" offset="0"/><stop class="p360-h2" offset="0.36"/><stop class="p360-h3" offset="0.68"/><stop class="p360-h4" offset="1"/>' +
    '</linearGradient></defs>' +
    '<circle class="p360-dial__track" cx="120" cy="120" r="96" style="stroke-width:28"/>' +
    '<circle class="p360-dial__arc" cx="120" cy="120" r="96" stroke="url(#p360h-cart)" stroke-dasharray="603.19 603.19" transform="rotate(-90 120 120)" style="stroke-dashoffset:150.8;stroke-width:28"/></svg>';

  var cartBusy = false;
  function renderCartEarn() {
    var totals = document.querySelectorAll('.cart-drawer__footer .totals, #main-cart-footer .totals');
    if (!totals.length || cartBusy) return;
    cartBusy = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var earn = Math.floor((cart.total_price || 0) / 100);
        totals.forEach(function (t) {
          var line = t.parentNode.querySelector('.p360-cart');
          if (earn <= 0) {
            if (line) line.remove();
            return;
          }
          if (!line) {
            line = document.createElement('p');
            line.className = 'p360 p360-cart';
            t.insertAdjacentElement('afterend', line);
          }
          line.innerHTML =
            CART_ICON + '<span>Cette commande te rapporte <strong>' + fmt(earn) + ' Pano Points</strong>.</span>';
        });
      })
      .catch(function () {})
      .then(function () {
        cartBusy = false;
      });
  }

  var cartTimer = null;
  function scheduleCartEarn() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(renderCartEarn, 250);
  }

  function watchCart() {
    renderCartEarn();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function (records) {
        var ours = records.every(function (rec) {
          if (rec.target.nodeType === 1 && rec.target.closest('.p360-cart')) return true;
          var nodes = Array.prototype.slice.call(rec.addedNodes).concat(Array.prototype.slice.call(rec.removedNodes));
          return (
            nodes.length > 0 &&
            nodes.every(function (n) {
              return n.nodeType === 1 && n.classList.contains('p360-cart');
            })
          );
        });
        if (!ours) scheduleCartEarn();
      }).observe(drawer, { childList: true, subtree: true });
    }
    // subscribe et PUB_SUB_EVENTS viennent de pubsub.js et constants.js (Dawn)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCartEarn);
    }
  }

  /*
   * Reflet holographique : le dégradé des cadrans tourne (animation SVG) et la carte Wallet suit le doigt
   * ou la souris. Tout est coupé si l'appareil demande de réduire les animations.
   */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function calmDials() {
    if (!reduceMotion) return;
    document.querySelectorAll('svg.p360-dial').forEach(function (svg) {
      if (svg.pauseAnimations) svg.pauseAnimations();
    });
  }

  function bindTilt() {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('pointermove', function (event) {
      var card = event.target.closest && event.target.closest('[data-p360-tilt]');
      if (!card) return;
      var box = card.getBoundingClientRect();
      var x = (event.clientX - box.left) / box.width;
      var y = (event.clientY - box.top) / box.height;
      card.style.setProperty('--p360-mx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--p360-my', (y * 100).toFixed(1) + '%');
      card.style.setProperty('--p360-rx', ((0.5 - y) * 8).toFixed(2) + 'deg');
      card.style.setProperty('--p360-ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
      card.classList.add('is-tilting');
    });
    document.addEventListener(
      'pointerleave',
      function (event) {
        var card = event.target.closest && event.target.closest('[data-p360-tilt]');
        if (!card || event.target !== card) return;
        card.classList.remove('is-tilting');
        ['--p360-mx', '--p360-my', '--p360-rx', '--p360-ry'].forEach(function (k) {
          card.style.removeProperty(k);
        });
      },
      true
    );
  }

  /*
   * Simulateur du cadran (page programme) : dépense annuelle → angle, Pano Points, bons, avantage du palier.
   * Mêmes règles que snippets/p360-degrees.liquid et snippets/p360-rewards.liquid.
   */
  // Les textes des avantages viennent de la page (data-perk-90/180/360, rendus par snippets/p360-perks.liquid)
  var TIER_INFO = [
    { min: 1500, tier: 360 },
    { min: 500, tier: 180 },
    { min: 0, tier: 90 }
  ];
  var VOUCHERS = [
    [2000, 60],
    [1000, 25],
    [500, 10]
  ];

  function spendToDeg(s) {
    if (s >= 1500) return 360;
    if (s >= 500) return 180 + ((s - 500) * 180) / 1000;
    return 90 + (s * 90) / 500;
  }

  function degToSpend(d) {
    return d <= 180 ? ((d - 90) * 500) / 90 : 500 + ((d - 180) * 1000) / 180;
  }

  function voucherTotal(points) {
    var total = 0;
    VOUCHERS.forEach(function (v) {
      while (points >= v[0]) {
        points -= v[0];
        total += v[1];
      }
    });
    return total;
  }

  function initSim(box) {
    if (box.__p360) return;
    box.__p360 = true;
    var svg = box.querySelector('svg.p360-dial');
    var range = box.querySelector('[data-p360-sim-range]');
    if (!svg || !range) return;
    var arc = svg.querySelector('.p360-dial__arc');
    var value = svg.querySelector('.p360-dial__value');
    var marks = svg.querySelectorAll('.p360-dial__mark');
    var spendOut = box.querySelector('[data-p360-sim-spend]');
    var out = box.querySelector('[data-p360-sim-out]');
    var CIRC = 603.19;
    var lastDeg = 180;

    function update(fromUser) {
      var s = parseInt(range.value, 10) || 0;
      var d = spendToDeg(s);
      lastDeg = d;
      if (fromUser) arc.classList.remove('p360-dial__arc--sweep');
      arc.style.strokeDashoffset = (CIRC * (1 - d / 360)).toFixed(2);
      var points = s + 100;
      if (value) value.textContent = fmt(points);
      // ordre des repères dans le SVG : 90° (droite), 180° (bas), 360° (haut)
      [90, 180, 360].forEach(function (threshold, i) {
        if (marks[i]) marks[i].classList.toggle('p360-dial__mark--off', d < threshold);
      });
      var info = TIER_INFO.filter(function (t) {
        return s >= t.min;
      })[0];
      var v = voucherTotal(points);
      var perk = box.getAttribute('data-perk-' + info.tier) || '';
      spendOut.textContent = fmt(s) + ' €';
      out.textContent =
        'Palier ' +
        info.tier +
        '°. ' +
        (v ? 'Jusqu’à ' + v + ' € de bons. ' : 'Ton premier bon arrive à 500 Pano Points. ') +
        perk;
      range.setAttribute('aria-valuetext', fmt(s) + ' € par an, palier ' + info.tier + '°');
    }

    range.addEventListener('input', function () {
      update(true);
    });

    // Tourner directement le cadran
    var dragging = false;
    function fromPointer(event) {
      var b = svg.getBoundingClientRect();
      var x = event.clientX - (b.left + b.width / 2);
      var y = event.clientY - (b.top + b.height / 2);
      var a = ((Math.atan2(x, -y) * 180) / Math.PI + 360) % 360;
      var current = parseInt(range.value, 10) || 0;
      var s;
      if (a < 90) {
        s = lastDeg > 270 ? Math.max(1500, current) : 0;
      } else if (a > 355) {
        s = Math.max(1500, current);
      } else {
        s = Math.round(degToSpend(a) / 50) * 50;
      }
      range.value = String(Math.max(0, Math.min(3000, s)));
      update(true);
    }
    svg.addEventListener('pointerdown', function (event) {
      dragging = true;
      try {
        svg.setPointerCapture(event.pointerId);
      } catch (e) {}
      fromPointer(event);
    });
    svg.addEventListener('pointermove', function (event) {
      if (dragging) fromPointer(event);
    });
    ['pointerup', 'pointercancel'].forEach(function (type) {
      svg.addEventListener(type, function () {
        dragging = false;
      });
    });

    update(false);
  }

  /*
   * ---------- Jeux (maquette) ----------
   * SÉCURITÉ, version réelle : rien de ce qui suit ne décide d'un gain. Le navigateur demande seulement
   * « mon ticket du jour » à notre serveur, via le proxy d'app Shopify qui signe l'identité du client connecté
   * (impossible de jouer pour un autre compte ou sans compte). Le serveur :
   *  1. refuse s'il existe déjà un ticket pour ce compte aujourd'hui (verrou unique en base : 50 clics
   *     simultanés donnent toujours un seul ticket) ;
   *  2. tire le gain avec un générateur aléatoire sûr et applique les plafonds (150 points de jeu par mois
   *     et par compte, 2 jackpots par mois pour toute la boutique, points doublés limités à +300) ;
   *  3. enregistre le résultat puis crédite les points dans l'app fidélité ;
   *  4. renvoie seulement le gain à afficher. Gratter ne fait que dévoiler un résultat déjà écrit.
   * Ici, en maquette, on simule ce tirage dans le navigateur et rien n'est crédité.
   * Les chances sont les mêmes que dans le tableau de la page programme (sur 10 000 tickets).
   */
  var PRIZES = [
    { w: 4995, win: '+2', what: 'Pano Points', pts: 2 },
    { w: 2500, win: '+5', what: 'Pano Points', pts: 5 },
    { w: 1200, win: '×2', what: 'Points doublés sur ta prochaine commande, pendant 72 h', pts: 0, big: true, kind: 'boost' },
    { w: 800, win: '+10', what: 'Pano Points', pts: 10, big: true },
    { w: 400, win: 'Offert', what: 'Livraison offerte sur ta prochaine commande, pendant 7 jours', pts: 0, big: true, kind: 'ship' },
    { w: 100, win: '+50', what: 'Pano Points', pts: 50, big: true },
    { w: 5, win: '+500', what: 'Pano Points, le jackpot', pts: 500, big: true, jackpot: true }
  ];
  var GAME_CAP = 150;
  var STREAK_BONUS = 15;

  function drawPrize() {
    var n = 0;
    try {
      var r = new Uint32Array(1);
      window.crypto.getRandomValues(r);
      n = r[0] % 10000;
    } catch (e) {
      n = Math.floor(Math.random() * 10000);
    }
    for (var i = 0; i < PRIZES.length; i++) {
      if (n < PRIZES[i].w) return i;
      n -= PRIZES[i].w;
    }
    return 0;
  }

  function parisParts() {
    var o = {};
    try {
      new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      })
        .formatToParts(new Date())
        .forEach(function (p) {
          o[p.type] = p.value;
        });
    } catch (e) {
      var d = new Date();
      o = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes(), second: d.getSeconds() };
    }
    return o;
  }

  function parisDay() {
    var o = parisParts();
    return o.year + '-' + o.month + '-' + o.day;
  }

  function untilMidnight() {
    var o = parisParts();
    var s = 86400 - (Number(o.hour) * 3600 + Number(o.minute) * 60 + Number(o.second));
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    return h + ' h ' + String(m).padStart(2, '0');
  }

  function describe(p) {
    if (p.jackpot) return 'Jackpot ! Tu gagnes 500 Pano Points, de quoi créer un bon de 10 €.';
    if (p.kind === 'boost') return 'Tes points sont doublés sur ta prochaine commande pendant 72 h (jusqu’à +300 Pano Points).';
    if (p.kind === 'ship') return 'La livraison est offerte sur ta prochaine commande pendant 7 jours.';
    return 'Tu gagnes ' + p.pts + ' Pano Points.';
  }

  function paintFoil(canvas) {
    var box = canvas.getBoundingClientRect();
    if (!box.width || !box.height) return false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(box.width * dpr);
    canvas.height = Math.round(box.height * dpr);
    var ctx = canvas.getContext('2d');
    var w = box.width;
    var h = box.height;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createLinearGradient(0, 0, w, h);
    var stops = ['#d9cdff', '#c2e9ff', '#f4f2ff', '#ffe0bf', '#ffcfe5', '#d9cdff'];
    stops.forEach(function (c, i) {
      g.addColorStop(i / (stops.length - 1), c);
    });
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    // fines rayures en biais, comme une feuille holographique
    ctx.save();
    ctx.globalAlpha = 0.35;
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 1;
    for (var x = -h; x < w; x += 7) {
      ctx.beginPath();
      ctx.moveTo(x, h);
      ctx.lineTo(x + h, 0);
      ctx.stroke();
    }
    ctx.restore();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = 'rgba(0, 0, 0, 0.86)';
    ctx.font = Math.round(h * 0.3) + 'px BBHbogle, Inter, sans-serif';
    ctx.fillText('GRATTE ICI', w / 2, h * 0.46);
    ctx.fillStyle = 'rgba(0, 0, 0, 0.55)';
    ctx.font = '600 ' + Math.max(11, Math.round(h * 0.075)) + 'px Inter, sans-serif';
    ctx.fillText('1 ticket par jour', w / 2, h * 0.72);
    return true;
  }

  function initTicket(root) {
    if (root.__p360) {
      root.__p360.paint();
      return;
    }
    var canvas = root.querySelector('.p360-ticket__foil');
    var winEl = root.querySelector('[data-p360-ticket-win]');
    var whatEl = root.querySelector('[data-p360-ticket-what]');
    var prizeEl = root.querySelector('[data-p360-ticket-prize]');
    var status = root.querySelector('[data-p360-ticket-status]');
    var btnAll = root.querySelector('[data-p360-scratch-all]');
    var btnReset = root.querySelector('[data-p360-ticket-reset]');
    var key = root.getAttribute('data-p360-ticket');
    var demo = root.hasAttribute('data-demo');
    var baseStreak = parseInt(root.getAttribute('data-streak'), 10) || 0;
    var baseMonth = parseInt(root.getAttribute('data-month'), 10) || 0;
    var storeKey = 'p360-ticket-' + key + '-' + parisDay();
    var defaultStatus = status.textContent;
    var scope = root.closest('[data-p360-dashboard]') || root.closest('.p360-games') || document;
    var prizeIndex = 0;
    var revealed = false;
    var scratching = false;
    var last = null;
    var moves = 0;

    function setPrize(i) {
      prizeIndex = i;
      var p = PRIZES[i];
      winEl.textContent = p.win;
      whatEl.textContent = p.what;
      prizeEl.classList.toggle('is-big', !!p.big);
      prizeEl.classList.toggle('is-jackpot', !!p.jackpot);
    }

    function paint() {
      if (revealed) return;
      var go = function () {
        paintFoil(canvas);
      };
      if (document.fonts && document.fonts.load) {
        document.fonts.load('40px BBHbogle').then(go, go);
      } else {
        go();
      }
    }

    function clearedRatio() {
      try {
        var data = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data;
        var total = 0;
        var clear = 0;
        for (var i = 3; i < data.length; i += 64) {
          total++;
          if (data[i] === 0) clear++;
        }
        return total ? clear / total : 0;
      } catch (e) {
        return 1;
      }
    }

    function showStreak(streak) {
      var box = scope.querySelector('[data-p360-streak]');
      if (!box) return;
      var count = box.querySelector('[data-p360-streak-count]');
      if (count) count.textContent = streak;
      box.querySelectorAll('li').forEach(function (li) {
        var day = parseInt(li.getAttribute('data-day'), 10);
        li.classList.toggle('is-done', day <= streak);
        li.classList.toggle('is-today', day === streak + 1 && streak === baseStreak);
      });
    }

    function showMonth(month) {
      var n = scope.querySelector('[data-p360-month]');
      var bar = scope.querySelector('[data-p360-month-bar]');
      if (n) n.textContent = month;
      if (bar) bar.style.width = Math.min(100, (month * 100) / GAME_CAP) + '%';
    }

    function reveal(silent) {
      if (revealed) return;
      revealed = true;
      root.classList.add('is-revealed');
      btnAll.hidden = true;
      btnReset.hidden = false;
      var p = PRIZES[prizeIndex];
      if (demo) {
        status.textContent = 'Ticket d’essai : ' + describe(p) + ' Crée ton compte pour jouer pour de vrai, chaque jour.';
        return;
      }
      if (!silent) store(storeKey, String(prizeIndex));
      var streak = Math.min(7, baseStreak + 1);
      var bonus = streak === 7 ? STREAK_BONUS : 0;
      var counted = (p.jackpot ? 0 : p.pts) + bonus;
      var credited = Math.min(counted, Math.max(0, GAME_CAP - baseMonth));
      showStreak(streak);
      showMonth(baseMonth + credited);
      var message = describe(p);
      if (bonus) message += ' Série de 7 jours : +' + STREAK_BONUS + ' Pano Points en bonus.';
      if (credited < counted) message += ' Plafond du mois atteint.';
      status.textContent = message + ' Prochain ticket dans ' + untilMidnight() + '.';
    }

    function reset() {
      store(storeKey, null);
      revealed = false;
      root.classList.remove('is-revealed');
      btnAll.hidden = false;
      btnReset.hidden = true;
      status.textContent = defaultStatus;
      if (!demo) {
        showStreak(baseStreak);
        showMonth(baseMonth);
      }
      setPrize(drawPrize());
      paint();
    }

    function scratchTo(x, y) {
      var ctx = canvas.getContext('2d');
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = 44;
      ctx.beginPath();
      if (last) ctx.moveTo(last.x, last.y);
      else ctx.moveTo(x - 0.1, y);
      ctx.lineTo(x, y);
      ctx.stroke();
      last = { x: x, y: y };
      moves++;
      if (moves % 10 === 0 && clearedRatio() > 0.5) reveal();
    }

    function pos(event) {
      var b = canvas.getBoundingClientRect();
      return { x: event.clientX - b.left, y: event.clientY - b.top };
    }

    canvas.addEventListener('pointerdown', function (event) {
      if (revealed) return;
      scratching = true;
      last = null;
      try {
        canvas.setPointerCapture(event.pointerId);
      } catch (e) {}
      var p = pos(event);
      scratchTo(p.x, p.y);
      event.preventDefault();
    });
    canvas.addEventListener('pointermove', function (event) {
      if (!scratching || revealed) return;
      var p = pos(event);
      scratchTo(p.x, p.y);
    });
    ['pointerup', 'pointercancel'].forEach(function (type) {
      canvas.addEventListener(type, function () {
        scratching = false;
        last = null;
        if (!revealed && clearedRatio() > 0.5) reveal();
      });
    });
    btnAll.addEventListener('click', function () {
      reveal();
    });
    btnReset.addEventListener('click', reset);

    root.__p360 = { paint: paint };

    var saved = demo ? null : load(storeKey);
    if (saved !== null && PRIZES[parseInt(saved, 10)]) {
      setPrize(parseInt(saved, 10));
      reveal(true);
    } else {
      setPrize(drawPrize());
      paint();
    }
  }

  /*
   * « Devine le prix » (maquette) : le vrai prix est dans la page pour dévoiler le résultat tout de suite.
   * En production, il reste sur le serveur jusqu'à l'ouverture de l'arrivage.
   */
  function initGuess(box) {
    if (box.__p360) return;
    box.__p360 = true;
    var input = box.querySelector('[data-p360-guess-input]');
    var out = box.querySelector('[data-p360-guess-out]');
    var btn = box.querySelector('[data-p360-guess-submit]');
    var result = box.querySelector('[data-p360-guess-result]');
    var answer = parseInt(box.getAttribute('data-answer'), 10);
    function show() {
      out.textContent = fmt(input.value) + ' €';
      input.setAttribute('aria-valuetext', fmt(input.value) + ' euros');
    }
    input.addEventListener('input', show);
    show();
    btn.addEventListener('click', function () {
      var guess = parseInt(input.value, 10);
      var gap = Math.abs(guess - answer) / answer;
      var pct = Math.round(gap * 100);
      var win = gap <= 0.1;
      input.disabled = true;
      btn.disabled = true;
      box.classList.add('is-done', win ? 'is-win' : 'is-miss');
      result.innerHTML =
        'Prix réel : <strong>' +
        fmt(answer) +
        ' €</strong>. ' +
        (win ? 'Tu es à ' + pct + ' % : +20 Pano Points !' : 'Écart de ' + pct + ' % : raté, prochaine pièce jeudi.') +
        '<span>Maquette : en vrai, la réponse tombe à l’ouverture de l’arrivage.</span>';
    });
  }

  function initGames(scope) {
    scope.querySelectorAll('[data-p360-ticket]').forEach(function (t) {
      if (t.offsetParent !== null || t.getClientRects().length) initTicket(t);
    });
    scope.querySelectorAll('[data-p360-guess]').forEach(initGuess);
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-p360-ticket]').forEach(function (t) {
        if (t.__p360 && t.getClientRects().length) t.__p360.paint();
      });
    }, 200);
  }

  // Pour les pages qui affichent un bloc caché après coup (ex. onglets de la maquette)
  window.p360Refresh = function (scope) {
    initGames(scope || document);
  };

  function start() {
    watchCart();
    calmDials();
    bindTilt();
    document.querySelectorAll('[data-p360-sim]').forEach(initSim);
    initGames(document);
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest(
      '[data-p360-profile], [data-p360-copy], [data-p360-mock]'
    );
    if (!target) return;

    if (target.hasAttribute('data-p360-profile')) {
      setProfile(target.getAttribute('data-p360-profile'));
    } else if (target.hasAttribute('data-p360-copy')) {
      copy(target.getAttribute('data-p360-copy'));
    } else if (target.hasAttribute('data-p360-mock')) {
      toast(target.getAttribute('data-p360-mock'));
    }
  });
})();
